export function formatCurrency(number, currency, location) {
  return parseFloat(number).toLocaleString(location, {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2
  });
}
